import { render, staticRenderFns } from "./DocumentGroupSelect.vue?vue&type=template&id=374453fe&"
import script from "./DocumentGroupSelect.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports